/* eslint-disable default-case */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import WebapiCommon from '@common/util/webapi.common';
import TarefasApi from './tarefas.api';
import { getUsuarioLocalStorage } from '../../localStorage.util';
import TarefasKanbanPage from './tarefas.kanban.page';
import Card from './Card';
import CommonFunctions from '@common/util/functions.common';
import * as commonActions from '@common/common.action';
import * as actions from './tarefas.action';
import { enumFiltroListUrgente } from '@common/util/defaultValues';
import LaudoPreview from '../laudo/Preview';
import { quadroKanbanEnum, enumFiltroTipo, colorsSystem } from '@common/util/defaultValues';
import IntlMessage from "../../helpers/intlMessage";
import { changePeriod, getDate, obterListagemDePeriodos, validarData } from '../../helpers';

class TarefasContainer extends Component {
  constructor(props) {
    super(props);
    this.usuarioLocal = getUsuarioLocalStorage();
    const periodo = CommonFunctions.getPeriodosSubDays(0);

    this.state = {
      periodoInicial: periodo.periodoInicial,
			periodoFinal: periodo.periodoFinal,
      periodo: { value: 'hoje', label: `${this.props.intl.formatMessage({ id: "period.today" })}` },
			periodos: []
    }

    this.getDate = getDate.bind(this);
		this.changePeriod = changePeriod.bind(this);
    this.obterListagemDePeriodos = obterListagemDePeriodos.bind(this);
    this.validarData = validarData.bind(this);
		this.periodoAlterado(this.state.periodo);
  }

  componentDidMount() {
    if (this.props.tarefas.isFirstLoad) {
      this.props.commonActions.showFadeCarregando(true);
      Promise.all([
        WebapiCommon.getMedicos(),
        WebapiCommon.getTiposExame()
      ]).then(res => {
        let state = { ...this.props.tarefas };
        state.medicos.push({
          label: `${this.props.intl.formatMessage({id:"dashboards.reports.all"}) }`,
          value: null
        });
        this.props.actions.medicos(state.medicos.concat(res[0]));
        this.props.actions.tiposExame(res[1]);
        this.props.actions.periodoInicial(this.state.periodoInicial);
        this.props.actions.periodoFinal(this.state.periodoFinal);

        this.props.actions.medicoSelecionado(
          this.props.tarefas.medicos.find(
            x => x.value === this.usuarioLocal.medicoId
          )
        );

        this.filtrar(
          this.usuarioLocal.medicoId,
          this.props.tarefas.periodoInicial,
          this.props.tarefas.periodoFinal,
          this.props.tarefas.tipoFiltro,
          this.props.tarefas.tipoFiltroValue,
          this.props.tarefas.ordenacao
        );
      });
      this.props.actions.isFirstLoad(false);
    }

    this.setState({periodos: this.obterListagemDePeriodos(this.props.intl)});
  }

	resetarPeriodo = () => {
		this.setState({periodo: '', periodoInicial: null, periodoFinal: null})
	}

	periodoAlterado = (e) => {
		if (!e || !e.value) {
		  return this.resetarPeriodo();
		}

		let payload = this.getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

		this.setState({
			periodo: e,
			periodoInicial: payload.dtinicial,
			periodoFinal: payload.dtfinal})
	}

	mudarIntervaloPeriodo = (val) => {
		let payload = this.changePeriod(val);

		this.setState({
			periodoInicial: payload.start,
			periodoFinal: payload.end})
	}

	eventoOnKeyPressData(event) {
		if (event.key === "Enter")
			this.executarFiltro();
	}

  filtrar(
    medico,
    dataInicial,
    dataFinal,
    tipoFiltro,
    tipoFiltroValue,
    ordenacao
  ) {
    let datasValidas = true;

    if (tipoFiltro.indexOf('dt') >= 0) {
      if (medico == null)
        datasValidas = this.validarData(this.state.periodoInicial, this.state.periodoFinal, this.props.intl, this.props.commonActions);
      else {
        let executarValidacaoDeData =
         	((this.state.periodoInicial != null) && this.state.periodoInicial != '') ||
         	((this.state.periodoFinal != null) && this.state.periodoFinal != '');
        datasValidas = !executarValidacaoDeData ? true :
         	this.validarData(this.state.periodoInicial, this.state.periodoFinal, this.props.intl, this.props.commonActions);
      }
    }

    if (datasValidas) {
      this.props.commonActions.showFadeCarregando(true);
      TarefasApi.obterListaTarefas(
        medico,
        dataInicial,
        dataFinal,
        tipoFiltro,
        tipoFiltroValue,
        ordenacao
      ).then(res => {
        let { listaKanbam } = this.props.tarefas;

        let pendentesDeRevisao = res
          .filter(el => el.status === quadroKanbanEnum.TM_PENDENTES.status || el.status === quadroKanbanEnum.TM_PENDENTESEXUCUCAO.status)
          .map(el =>
            this.criarItemKanbam(el, el.status)
          );

        let revisadosConcluidos = res
          .filter(el => el.status === quadroKanbanEnum.TM_REVISADOS.status)
          .map(el =>
            this.criarItemKanbam(el, quadroKanbanEnum.TM_REVISADOS.status)
          );

        listaKanbam = this.getKanbam(pendentesDeRevisao, revisadosConcluidos);

        this.props.actions.listaKanbam(listaKanbam);

        this.props.commonActions.showFadeCarregando(false);

        if (res.length === 0) {
          this.props.commonActions.showAlerta(
            'alerta',
            <IntlMessage id = "dashboards.reports.noResultsFound"/>,
            1500
          );
        }
      });
    }
  }

  criarItemKanbam(item, etapa) {
    let id = `tarefa_${item.etapa}_${item.laudoId}_${item.exame}_${etapa}`;
    let content = (
      <Card laudo={item} showPreview={this.showPreview.bind(this)} />
    );

    return {
      id: id,
      data: item,
      isDragDisabled: item.existeNConformidade === 1,
      draggableStyle: { borderLeft: '#333' },
      content
    };
  }

  getKanbam(pendentesDeRevisao, revisadosConcluidos) {
    this.props.actions.pendentesDeRevisaoCount(pendentesDeRevisao.length);
    this.props.actions.revisadosConcluidosCount(revisadosConcluidos.length);

    return [
      {
        pendentesDeRevisao: pendentesDeRevisao,
        title: {
          text: `${this.props.intl.formatMessage({id:"dashboards.doctorTasks.examsToReview"}) }`,
          color: colorsSystem.VERMELHO
        },
        count: this.props.tarefas.pendentesDeRevisaoCount
      },
      {
        revisadosConcluidos: revisadosConcluidos,
        title: {
          text: `${this.props.intl.formatMessage({id:"dashboards.doctorTasks.revisedExams"}) }`,
          color: colorsSystem.VERDE
        },
        count: this.props.tarefas.revisadosConcluidosCount
      }
    ];
  }

  onChangeData(name, value) {
    this.setState({[name]: value});
  }

  onChangeMedico(medico) {
    this.props.actions.medicoSelecionado(medico);

    this.filtrar(
      medico.value,
      this.props.tarefas.periodoInicial,
      this.props.tarefas.periodoFinal,
      this.props.tarefas.tipoFiltro,
      this.props.tarefas.tipoFiltroValue,
      this.props.tarefas.ordenacao
    );
  }

  onChangeInputText(name, value) {
    this.props.actions.tipoFiltro(name);
    this.props.actions.tipoFiltroValue(value);
  }

  onKeyPressInputText(event) {
    if (event.key === 'Enter') {
      this.executarFiltro();
    }
  }

  executarFiltro() {
    let {
      //periodoInicial,
      //periodoFinal,
      medicoSelecionado,
      tipoFiltro,
      tipoFiltroValue,
      ordenacao
    } = this.props.tarefas;

    let medico = !!medicoSelecionado ? medicoSelecionado.value : null;
    this.filtrar(
      medico,
      this.state.periodoInicial,
      this.state.periodoFinal,
      tipoFiltro,
      tipoFiltroValue,
      ordenacao
    );
  }

  onChangeSelect(e) {
    this.props.actions.tipoFiltroValue(e.value);

    this.props.actions.optionFiltroInputTypeSelectSelecionada(
      this.props.tarefas.optionsFiltroInputTypeSelect.find(
        x => x.value === e.value
      )
    );

    if (e.value !== '') {
      let {
        periodoInicial,
        periodoFinal,
        medicoSelecionado,
        tipoFiltro,
        ordenacao
      } = this.props.tarefas;

      let medico = !!medicoSelecionado ? medicoSelecionado.value : null;

      this.filtrar(
        medico,
        periodoInicial,
        periodoFinal,
        tipoFiltro,
        e.value,
        ordenacao
      );
    }
  }

  onChangeTipoFiltro(e) {
    this.props.actions.tipoFiltroSelecionado(e);
    this.props.actions.tipoFiltro(e.value);
    this.props.actions.tipoFiltroValue('');

    if (e.value != enumFiltroTipo.DATA_ENTREGA && e.value != enumFiltroTipo.DATA_SOLICITACAO)
      this.resetarPeriodo();

    this.props.actions.optionFiltroInputTypeSelectSelecionada(null);
    switch (e.value) {
      case enumFiltroTipo.URGENTE:
        this.props.actions.optionsFiltroInputTypeSelect(enumFiltroListUrgente);
        break;
      case enumFiltroTipo.TIPO_EXAME:
        this.props.actions.optionsFiltroInputTypeSelect(
          this.props.tarefas.tiposExame
        );
        break;
    }
  }

  onDragEndOverride(result) {
    const { source, destination } = result;

    var origem = {
      pendentesDeRevisao: 0,
      revisadosConcluidos: 1
    };

    let { listaKanbam } = this.props.tarefas;

    let item =
      listaKanbam[origem[source.droppableId]][source.droppableId][source.index];
    let error =
      item.data.bloqueado === 'S'
        ? `${this.props.intl.formatMessage({id:"dashboards.immunology.blockedImpedingNonconformity"}) }`
        : '';

    error = !(source && destination) ? `${this.props.intl.formatMessage({id:"dashboards.immunology.unexpectedErrorOccurred"}) }`  : '';

    if (error === '') {
      this.move(source, destination);
    } else {
      this.props.commonActions.showAlerta('erro', error, 2000);
    }
  }

  move(source, destination) {
    let listaKanbam = cloneDeep(this.props.tarefas.listaKanbam);
    let origem = listaKanbam.find(
      e => Object.keys(e)[0] === source.droppableId
    );
    let destino = listaKanbam.find(
      e => Object.keys(e)[0] === destination.droppableId
    );
    let movido = origem[source.droppableId].splice(source.index, 1)[0];
    let etapa =
      destination.droppableId === quadroKanbanEnum.TM_REVISADOS.id
        ? quadroKanbanEnum.TM_REVISADOS.status
        : quadroKanbanEnum.TM_PENDENTES.status;
    let status =
      destination.droppableId === quadroKanbanEnum.TM_REVISADOS.id ? 'S' : 'P';

    TarefasApi.atualizarStatusDoLaudo(
      movido.data.laudoId,
      status,
      movido.data.etapa
    ).then(() => {
      destino[destination.droppableId].splice(
        destination.index,
        0,
        this.criarItemKanbam(movido.data, etapa)
      );

      destino[destination.droppableId] = destino[destination.droppableId].sort(
        (a, b) => {
          return a.data.idLamina - b.data.idLamina;
        }
      );

      listaKanbam[0].count = listaKanbam[0].pendentesDeRevisao
        ? listaKanbam[0].pendentesDeRevisao.length
        : 0;
      listaKanbam[1].count = listaKanbam[1].revisadosConcluidos
        ? listaKanbam[1].revisadosConcluidos.length
        : 0;

      this.props.actions.listaKanbam(listaKanbam);
      this.props.actions.pendentesDeRevisaoCount(
        listaKanbam[0].pendentesDeRevisao
          ? listaKanbam[0].pendentesDeRevisao.length
          : 0
      );
      this.props.actions.revisadosConcluidosCount(
        listaKanbam[1].revisadosConcluidos
          ? listaKanbam[1].revisadosConcluidos.length
          : 0
      );

      console.log(
        `[PENDENTES DE REVISÃO]:${this.props.tarefas.pendentesDeRevisaoCount}`
      );
      console.log(`[REVISADOS]:${this.props.tarefas.revisadosConcluidosCount}`);

      this.props.commonActions.showAlerta(
        'sucesso',
        `${this.props.intl.formatMessage({id:"dashboards.histology.successfullyMoved"}) }`,
        800
      );
    });
  }

  showPreview(laudo) {
    this.props.actions.laudo(laudo);
    this.props.actions.preview(true);
  }

  render() {
    let tarefasFiltroPageProps = {
      medicos: this.props.tarefas.medicos,
      optionsFiltroInputTypeSelect: this.props.tarefas.optionsFiltroInputTypeSelect,
      optionFiltroInputTypeSelectSelecionada: this.props.tarefas.optionFiltroInputTypeSelectSelecionada,
      medicoSelecionado: this.props.tarefas.medicoSelecionado,
      periodoInicial: this.state.periodoInicial,
      periodoFinal: this.state.periodoFinal,
      onChangeData: this.onChangeData.bind(this),
      onChangeMedico: this.onChangeMedico.bind(this),
      onChangeInputText: this.onChangeInputText.bind(this),
      onChangeSelect: this.onChangeSelect.bind(this),
      tipoFiltroSelecionado: this.props.tarefas.tipoFiltroSelecionado,
      onChangeTipoFiltro: this.onChangeTipoFiltro.bind(this),
      tipoFiltroValue: this.props.tarefas.tipoFiltroValue,
      usuario: this.props.usuario,
      filtrar: this.filtrar.bind(this),
      periodos: this.state.periodos,
      periodo: this.state.periodo,
      onChangePeriodo: this.periodoAlterado.bind(this),
      mudarIntervaloPeriodo: this.mudarIntervaloPeriodo.bind(this),
      onKeyPressData: this.eventoOnKeyPressData.bind(this)
    };

    let dragDropComponente = {
      listaKanbam: this.props.tarefas.listaKanbam,
      onDragEndOverride: this.onDragEndOverride.bind(this),
      alturaKanbam: `${window.innerHeight - 120}px`
    };
    return (
      <React.Fragment>
        {this.props.tarefas.laudo && (
          <LaudoPreview
            laudoId={this.props.tarefas.laudo.laudoId}
            etapa={this.props.tarefas.laudo.etapa}
            show={this.props.tarefas.preview}
            setShow={this.props.actions.preview}
          />
        )}

        <TarefasKanbanPage
          tarefasFiltroPageProps={tarefasFiltroPageProps}
          dragDropComponente={dragDropComponente}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    medicoPadrao: state.commonReducer.medicoPadraoMacroscopia,
    tarefas: state.tarefas,
    usuario: state.usuario
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TarefasContainer);



// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.container.js